import { getStoreAuth } from "./StorePanelPrivateRoute";
import StoreQrCard from "../StoreQrCard";

// Store panel "My QR": uses the store's qr_handle from the login response.
export default function StorePanelQR() {
    const store = getStoreAuth()?.store;

    return (
        <div className="mx-auto max-w-md">
            <div className="rounded-2xl border bg-white p-6 shadow-sm print:border-0 print:shadow-none">
                {store?.qr_handle ? (
                    <StoreQrCard storeName={store.store_name} handle={store.qr_handle} />
                ) : (
                    <p className="text-center text-sm text-gray-500">
                        Your QR isn't loaded yet. Please log out and log in again.
                    </p>
                )}
            </div>
        </div>
    );
}